export class ReactionSetDetails {

  sampleBarcode: string;
  primerName: string;
  primerType: string;
  positionInReactionPlate:  string;
  readLength: string;
  QCcomment: string;
  sampleName: string;
  orderID: string;
  premixProduct: string;
  redoCount: number;
  originalBarcode: string;
}
